import _ from 'lodash';

import common from '@common';

import * as t from './action_types';

const {
  utils: {
    messenger: {
      constants: { CONVERSATION_LIST_MODES, MESSENGER_VIEW_MODES },
      mockedData: {
        mockedConversations: { conversations },
      },
    },
  },
} = common;

export const initialState = {
  conversationList: {
    activeItem: null,
    conversations,
    hasNextPage: true,
    isFetching: true,
    listMode: CONVERSATION_LIST_MODES.READABLE,
    newMessageItemVisible: false,
    selectedConversationIds: [],
  },
  conversationSearch: {
    query: '',
  },
  displayContactDetails: false,
  dynamicPersonColors: {},
  recipients: {
    newRecipients: [],
    recipientsList: [],
    recipientsToUpdate: [],
    selectedRecipients: [],
    selectedRecipientsWithPhoneNumbers: [],
  },
  conversationThread: {
    activeConversationId: null,
    activeContactId: null,
    isFetching: false,
    isSending: false,
    isNewSending: false,
  },
  viewMode: MESSENGER_VIEW_MODES.COMPOUND,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case t.MESSENGER_TOGGLE_DISPLAY_CONTACT_DETAILS:
    case t.MESSENGER_SET_VIEW_MODE:
      return {
        ...state,
        ...action.payload,
      };
    case t.MESSENGER_CLEAR_ACTIVE_ITEM:
      return {
        ...state,
        conversationList: {
          ...state.conversationList,
          activeItem: null,
        },
      };
    case t.MESSENGER_CONVERSATION_LIST_SET_MODE:
    case t.MESSENGER_SELECT_CONVERSATION_LIST_ACTIVE_ITEM:
    case t.MESSENGER_SET_CONVERSATIONS_FETCHING_FLAG:
    case t.MESSENGER_SET_HAS_NEXT_PAGE_FLAG:
      return {
        ...state,
        conversationList: {
          ...state.conversationList,
          ...action.payload,
        },
      };
    case t.MESSENGER_TOGGLE_NEW_MESSAGE_ITEM:
      return {
        ...state,
        conversationThread: {
          ...initialState.conversationThread,
        },
        recipients: {
          ...initialState.recipients,
        },
        conversationList: {
          ...state.conversationList,
          ...action.payload,
        },
      };
    case t.MESSENGER_SELECT_CONVERSATION_RECIPIENTS_LIST: {
      const selectedRecipientsList = _.get(state, 'recipients.selectedRecipients', []);

      return {
        ...state,
        recipients: {
          ...state.recipients,
          selectedRecipients: _.concat(
            selectedRecipientsList,
            action.payload.selectedRecipientsList,
          ),
        },
      };
    }
    case t.MESSENGER_SELECT_CONVERSATION_RECIPIENTS_WITH_PHONE_NUMBERS: {
      const selectedRecipientsWithPhoneNumbers = _.get(
        state,
        'recipients.selectedRecipientsWithPhoneNumbers',
        [],
      );

      return {
        ...state,
        recipients: {
          ...state.recipients,
          selectedRecipientsWithPhoneNumbers: _.concat(
            selectedRecipientsWithPhoneNumbers,
            action.payload.selectedRecipientsWithPhoneNumbers,
          ),
        },
      };
    }
    case t.MESSENGER_SET_CONTACTS_TO_UPDATE_PHONE_NUMBERS: {
      return {
        ...state,
        recipients: {
          ...state.recipients,
          recipientsToUpdate: action.payload.contacts,
        },
      };
    }
    case t.MESSENGER_REMOVE_CONTACT_FROM_UPDATE_PHONE_NUMBERS: {
      const recipientsList = _.get(state, 'recipients.recipientsList', []);
      const recipientsToUpdate = _.get(state, 'recipients.recipientsToUpdate', []);
      const selectedRecipientsList = _.get(state, 'recipients.selectedRecipients', []);

      return {
        ...state,
        recipients: {
          ...state.recipients,
          selectedRecipients: _.filter(
            selectedRecipientsList,
            selectedRecipient => selectedRecipient !== action.payload.contactId,
          ),
          recipientsToUpdate: _.filter(
            recipientsToUpdate,
            recipient => recipient.id !== action.payload.contactId,
          ),
          recipientsList: _.filter(
            recipientsList,
            recipient => recipient.id !== action.payload.contactId,
          ),
        },
      };
    }
    case t.MESSENGER_RESET_CONTACTS_TO_UPDATE_PHONE_NUMBERS: {
      const recipientsList = _.get(state, 'recipients.recipientsList', []);
      const recipientsToUpdate = _.get(state, 'recipients.recipientsToUpdate', []);
      const selectedRecipientsList = _.get(state, 'recipients.selectedRecipients', []);

      return {
        ...state,
        recipients: {
          ...state.recipients,
          selectedRecipients: _.filter(
            selectedRecipientsList,
            selectedRecipient => !_.includes(_.map(recipientsToUpdate, 'id'), selectedRecipient),
          ),
          recipientsToUpdate: [],
          recipientsList: _.filter(
            recipientsList,
            recipient => !_.includes(_.map(recipientsToUpdate, 'id'), recipient.id),
          ),
        },
      };
    }
    case t.MESSENGER_CLEAR_CONTACTS_FOR_UPDATE_PHONE_NUMBERS: {
      return {
        ...state,
        recipients: {
          ...state.recipients,
          recipientsToUpdate: [],
        },
      };
    }
    case t.MESSENGER_REMOVE_SELECTED_RECIPIENT: {
      const selectedRecipients = _.get(state, 'recipients.selectedRecipients', []);
      const recipientsList = _.get(state, 'recipients.recipientsList', []);

      return {
        ...state,
        recipients: {
          ...state.recipients,
          recipientsList: _.filter(
            recipientsList,
            recipient => recipient.id !== action.payload.recipientID,
          ),
          selectedRecipients: _.filter(
            selectedRecipients,
            recipientID => recipientID !== action.payload.recipientID,
          ),
        },
      };
    }
    case t.MESSENGER_ADD_NEW_RECIPIENT: {
      const recipientsList = _.get(state, 'recipients.newRecipients', []);
      const newRecipients = [...recipientsList, action.payload.recipientPhone];

      return {
        ...state,
        recipients: {
          ...state.recipients,
          newRecipients,
        },
      };
    }
    case t.MESSENGER_ADD_CONTACT_TO_RECIPIENT_LIST: {
      const recipientsList = _.get(state, 'recipients.recipientsList', []);
      const newRecipients = [...recipientsList, ...action.payload.recipients_cell];

      return {
        ...state,
        recipients: {
          ...state.recipients,
          recipientsList: newRecipients,
        },
      };
    }
    case t.MESSENGER_CLEAR_RECIPIENT_LIST: {
      return {
        ...state,
        recipients: {
          ...state.recipients,
          recipientsList: [],
        },
      };
    }
    case t.MESSENGER_REMOVE_NEW_RECIPIENT: {
      const newRecipientsList = _.get(state, 'recipients.newRecipients', []);
      const recipientsListWithoutSelected = _.filter(
        newRecipientsList,
        phone => phone !== action.payload.recipientPhone,
      );

      return {
        ...state,
        recipients: {
          ...state.recipients,
          newRecipients: recipientsListWithoutSelected,
        },
      };
    }
    case t.MESSENGER_UPDATE_SEARCH_QUERY:
      return {
        ...state,
        conversationSearch: {
          ...state.conversationSearch,
          ...action.payload,
        },
      };
    case t.MESSENGER_MARK_CONVERSATION_AS_READ: {
      const conversationId = _.get(action, 'payload.conversationId', null);
      const oldConversations = _.get(state, 'conversationList.conversations', []);
      const newConversations = _.map(oldConversations, conversation => {
        if (conversationId && conversation.id === conversationId) {
          return {
            ...conversation,
            unread: false,
          };
        }

        return conversation;
      });

      return {
        ...state,
        conversationList: {
          ...state.conversationList,
          conversations: newConversations,
        },
      };
    }
    case t.MESSENGER_ADD_CONVERSATION_TO_SELECTED: {
      const conversationId = _.get(action, 'payload.conversationId', null);
      const oldSelectedConversationIds = _.get(
        state,
        'conversationList.selectedConversationIds',
        [],
      );

      if (conversationId) {
        return {
          ...state,
          conversationList: {
            ...state.conversationList,
            selectedConversationIds: [...oldSelectedConversationIds, conversationId],
          },
        };
      }

      return state;
    }
    case t.MESSENGER_REMOVE_CONVERSATION_FROM_SELECTED: {
      const conversationId = _.get(action, 'payload.conversationId', null);
      const oldSelectedConversationIds = _.get(
        state,
        'conversationList.selectedConversationIds',
        [],
      );

      if (conversationId) {
        const filteredSelectedConversationIds = _.filter(
          oldSelectedConversationIds,
          selectedConversationsId => selectedConversationsId !== conversationId,
        );

        return {
          ...state,
          conversationList: {
            ...state.conversationList,
            selectedConversationIds: filteredSelectedConversationIds,
          },
        };
      }

      return state;
    }
    case t.MESSENGER_CLEAR_SELECTED_CONVERSATIONS:
      return {
        ...state,
        conversationList: {
          ...state.conversationList,
          selectedConversationIds: [],
        },
      };
    case t.MESSENGER_SET_CONVERSATION_FETCHING_FLAG:
    case t.MESSENGER_SET_THREAD_ACTIVE_IDENTIFIERS:
    case t.MESSENGER_SET_SENDING_MESSAGE_FLAG:
    case t.MESSENGER_SET_NEW_SENDING_MESSAGE_FLAG:
      return {
        ...state,
        conversationThread: {
          ...state.conversationThread,
          ...action.payload,
        },
      };
    case t.MESSENGER_SET_PERSON_DYNAMIC_COLOR: {
      const { conversationId, modifier } = action.payload;

      return {
        ...state,
        dynamicPersonColors: {
          ...state.dynamicPersonColors,
          [conversationId]: modifier,
        },
      };
    }
    case t.MESSENGER_CONVERSATION_LIST_SET_FILTER:
      return {
        ...initialState,
        conversationList: {
          ...initialState.conversationList,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
